"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_atoms_icon_1 = __importDefault(require("@motorata/base-ui.components.atoms.icon"));
// eslint-disable-next-line @typescript-eslint/no-empty-function
const CheckboxesGroup = (_a) => {
    var { name, value = [], options = [], label, labelIcon, onChange = () => { } } = _a, rest = __rest(_a, ["name", "value", "options", "label", "labelIcon", "onChange"]);
    const handleOnChange = (e) => {
        onChange({
            name,
            value: e,
        });
    };
    const handleClick = (el) => {
        // @ts-ignore
        if (!(value === null || value === void 0 ? void 0 : value.includes(el))) {
            const arr = [...value, el];
            // @ts-ignore
            handleOnChange(arr);
        }
        else {
            // @ts-ignore
            handleOnChange(value.filter(e => e !== el));
        }
    };
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest),
        label && (react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary", icon: labelIcon, marginBottom: "XS" }, label)),
        react_1.default.createElement(Content, { className: "checkbox_group__content" }, options.map((el) => (
        // @ts-ignore
        react_1.default.createElement(Option, { key: el[1], active: value === null || value === void 0 ? void 0 : value.includes(el[1]), onClick: () => handleClick(el[1]) },
            react_1.default.createElement(Checkbox, { active: value === null || value === void 0 ? void 0 : value.includes(el[1]) },
                react_1.default.createElement(base_ui_components_atoms_icon_1.default, { icon: "check-basic", color: "white" })),
            react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "third" }, el[0])))))));
};
exports.default = CheckboxesGroup;
const Checkbox = styled_components_1.default.div `
  height: ${({ theme }) => theme.font.S};
  min-height: ${({ theme }) => theme.font.S};
  border-radius: 2px;
  width: ${({ theme }) => theme.font.S};
  max-width: ${({ theme }) => theme.font.S};
  margin-right: 8px;
  border: 1px solid ${({ theme }) => theme.color.third};
  color: ${({ theme }) => theme.color.fourth};
  display: flex;
  justify-items: center;
  align-items: center;

  svg {
    font-size: 3px;
    width: 8px;
    height: 8px;
    display: block !important;
    margin-left: 1px;
    opacity: 0;
  }

  ${({ active }) => active &&
    (0, styled_components_1.css) `
      border: 1px solid ${({ theme }) => theme.color.white};
      color: ${({ theme }) => theme.color.white};

      svg {
        opacity: 1;
      }
    `};
`;
const Option = styled_components_1.default.button `
  display: flex;
  align-items: center;
  padding: 8px 15px;
  background: ${({ theme }) => theme.color.fourth};
  color: ${({ theme }) => theme.color.third};
  border-radius: 3px;
  transition: all 0.3s;
  cursor: pointer;
  border: none;

  label {
    cursor: pointer !important;
  }

  &:hover {
    color: ${({ theme }) => theme.color.primary};
  }

  ${({ active }) => active &&
    (0, styled_components_1.css) `
      background: ${({ theme }) => theme.color.primary};

      label {
        color: ${({ theme }) => theme.color.white} !important;
      }
    `}
`;
const Content = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  display: flex;
  flex-wrap: wrap;
  grid-gap: ${({ theme }) => theme.space.XS};
`;
const Wrapper = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  * {
    box-sizing: border-box;
    font-family: "Poppins" !important;
  }
`;
//# sourceMappingURL=CheckboxesGroup.js.map